import React, { ChangeEvent } from "react";
import SelectField from "onnit-ui/lib/form/selectfield/SelectField";
import { SubscriptionIntervalEnum } from "onnit-ui/lib/@types/enums/SubscriptionInterval";

interface Props {
    interval: number | null;
    onChange: (e: ChangeEvent<HTMLSelectElement>) => void;
    isDisabled?: boolean;
}

export default function SubscriptionIntervalSelect(props: Props) {
    // Normalize to number.
    const interval = props.interval === null ? 0 : props.interval;
    // Values of enums include keys, too. Filter those out.
    const intervals = Object.values(SubscriptionIntervalEnum)
        .filter((element: number | string) => typeof element === "number");

    return (
        <SelectField label="Subscribe & Save 15% off MSRP" value={interval} onChange={props.onChange} disabled={props.isDisabled} width="100%">
            <option value={0}>Purchase this time only</option>
            {intervals.map((interval) => (
                <option value={interval} key={interval}>
                    Deliver every {interval.toString()} days
                </option>
            ))}
        </SelectField>
    );
}

SubscriptionIntervalSelect.defaultProps = {
    isDisabled: false,
};
